import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { LuSparkles, LuX } from 'react-icons/lu';

import { useAIChat } from '../../shared/contexts/AIChat.context';
import { ProactiveInsightEvent, useProactiveInsights } from '../../shared/hooks/use-proactive-insights';

// No visual footprint of its own — mounted once globally (Layout.tsx) alongside AIChatDrawer/
// OnboardingFlow. Surfaces a toast the moment JiraAgentV2 sends an unprompted risk-check insight,
// so the user notices it without having to open the AI drawer and check the studio session.
export function ProactiveInsights() {
  const { openChat } = useAIChat();

  const handleInsight = useCallback(
    (event: ProactiveInsightEvent) => {
      toast.custom(
        (t) => (
          <div
            className={`flex items-start gap-3 rounded-xl bg-base-100 shadow-panel p-4 max-w-sm transition-opacity ${
              t.visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <LuSparkles className="text-primary shrink-0 mt-0.5" />
            <div className="min-w-0 flex-1 space-y-1.5">
              <div className="text-sm font-semibold">New insight from your AI assistant</div>
              <div className="text-xs opacity-70 line-clamp-3">{event.message.text}</div>
              <button
                className="btn btn-primary btn-xs shadow-glow"
                onClick={() => {
                  openChat({});
                  toast.dismiss(t.id);
                }}
              >
                View
              </button>
            </div>
            <button className="btn btn-ghost btn-xs btn-circle shrink-0" onClick={() => toast.dismiss(t.id)}>
              <LuX size={14} />
            </button>
          </div>
        ),
        { duration: 15000 },
      );
    },
    [openChat],
  );

  useProactiveInsights(handleInsight);

  return null;
}

export default ProactiveInsights;
